<template>
  <span
    class="AiButton-content"
    :class="[{ 'AiButton-content--disabled': disabled }]">
    <button
      class="AiButton"
      :class="[`AiButton--${variant}`, { 'AiButton--disabled': disabled }]"
      :aria-busy="disabled"
      :disabled="disabled"
      :aria-label="label">
      <slot>
        <ai-icon
          v-if="selector === 'plus'"
          no-padding
          name="plus"
          :size="12"
          class="AiPause--icon" />
        <ai-icon
          v-else
          no-padding
          name="minus"
          :size="12"
          class="AiPlay--icon" />
      </slot>
    </button>
  </span>
</template>

<script setup lang="ts">
import AiIcon from '../AiIcon/AiIcon.vue';

export interface AiSelectorButtonProps {
  disabled?: boolean;
  label?: string;
  selector?: 'plus' | 'minus';
  variant?: 'positive' | 'inverse';
}

withDefaults(defineProps<AiSelectorButtonProps>(), {
  selector: 'plus',
  variant: 'positive',
  label: undefined,
});
</script>
<style scoped lang="scss">
@use '@/assets/styles/utilities/colors';
@use '@/assets/styles/utilities/mixins';

.AiButton-content {
  display: flex;
  align-items: center;

  &--disabled {
    pointer-events: none;
  }
}
.AiButton {
  /* Positioning */
  .AiPlay--icon {
    z-index: 1;
  }

  /* Display & Box Model */
  display: flex;
  flex-direction: row;
  justify-content: center;

  padding: 10px;

  /* Effects and Everything Else */
  cursor: pointer;
  transition: 0.2s ease;
  white-space: nowrap;

  @include mixins.rem-fallback(height, 36);
  @include mixins.rem-fallback(width, 36);
  @include mixins.rem-fallback(gap, 10);
  @include mixins.rem-fallback(border-radius, 100);

  /* Colors & Backgrounds */
  &--positive {
    background: colors.$gold-900;
    color: colors.$white;

    @media (any-hover: hover) and (prefers-reduced-motion: no-preference) {
      &:hover {
        background: colors.$gold-700;
      }
    }
  }

  &--inverse {
    background: colors.$gold-300;
    color: colors.$stratos-900;

    @media (any-hover: hover) and (prefers-reduced-motion: no-preference) {
      &:hover {
        background: colors.$gold-500;
      }
    }
  }

  &--disabled {
    opacity: 0.35;
  }
}
</style>
